import React from 'react';
import { Button, Modal } from 'antd';
import { mainAxios } from '../middleware/interceptor';
import { toast } from 'react-toastify';

function DeleteProductModal({ visible, setVisible, deleteProduct, updateCountSheet }) {

  const handleDeleteConfirm = () => {
    setVisible(false);
    const payload = {
      "RestId": parseInt(localStorage.getItem('RestId')),
      "CatId": deleteProduct.cat_id,
      "CatName": deleteProduct.catName,
      "CountSheetId": deleteProduct.CountSheetId,
      "subProductId": deleteProduct.subProductId,
      "SubCategoryId": ""
    }

    mainAxios.post(`api/Inventory/removeItemFromCountSheet`, payload).then((res) => {
      if (res?.data?.status == "1") {
        toast.success('Product deleted successfully');
        updateCountSheet(deleteProduct.CountSheetId);
      } else {
        toast.warning('Failed to delete a product');
      }
    }).catch((err) => { console.log(err) });
  };

  return (
    <Modal
      title='Delete'
      open={visible}
      onCancel={() => setVisible(false)}
      closable
      width={400}
      footer={[
        <Button
          onClick={() => setVisible(false)}
          className='Deactivate-Button'
        >
          Cancel
        </Button>,
        <Button
          onClick={handleDeleteConfirm}
        >
          Confirm
        </Button>
      ]}
    >
      <div>Are you sure want to delete?</div>
    </Modal>
  )
}

export default DeleteProductModal;
